// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different browser types
 * @enum
 */
export enum BrowserType {
    EdgeChromium = "edgeChromium"
}